export const POSITIVE_AMOUNT_REGEX = /^[+]?\d{1,10}([.]\d{0,2})?$/;
export const PHONE_NUMBER_REGEX = /^[+]?\d{8,15}$/;

export const verifyString = (v?: string | null): string => {
  if (!v) return '';

  return v;
};
